/**
 * Esegue `worker` su ogni elemento con al massimo `limit` chiamate contemporanee,
 * restituendo i risultati nello stesso ordine degli input.
 *
 * Il tetto serve a non saturare le connessioni per origine del browser: su HTTP/1.1
 * sono 6 e una è sempre occupata dallo stream realtime (SSE).
 */
export async function mapWithConcurrency<T, R>(
  items: T[],
  limit: number,
  worker: (item: T, index: number) => Promise<R>
): Promise<R[]> {
  const results: R[] = new Array(items.length);
  let nextIndex = 0;
  // Al primo errore si smette di avviare nuovi lavori: il risultato è comunque un rifiuto.
  let failed = false;

  const runners = Array.from({ length: Math.min(Math.max(limit, 1), items.length) }, async () => {
    while (!failed && nextIndex < items.length) {
      const current = nextIndex;
      nextIndex += 1;
      try {
        results[current] = await worker(items[current], current);
      } catch (error) {
        failed = true;
        throw error;
      }
    }
  });

  await Promise.all(runners);
  return results;
}

/** Tetto di richieste contemporanee per le letture a blocchi verso il server. */
export const REMOTE_READ_CONCURRENCY = 4;
